<template>
  <div class="space">
    <div class="history">
      <div class="his1">历本记录</div>
      <div class="his-body custom-scrollbar">
        <div v-if="his.length !== 0">
          <div class="item" v-for="(item, index) in his" :key="index" @click="checkhis(item)">{{ item.step_name }}: {{ item.user_input }}
          </div>
        </div>
        <el-empty v-else description="暂无数据"></el-empty>
      </div>
    </div>
    <div class="center">
      <div class="center-top">

        <!-- <div class="return" v-show="step != 0" @click="repage"><img src="@/assets/images/return.png" alt="">返回上一步</div> -->
        <!-- <div class="next" @click="nepage" v-show="allStep > step">下一步</div> -->
        <div class="step">
          <div :class="step == 0 ? 'item itemed' : 'item'">剧本创意</div>
          <div class="jt"><img v-show="step == 0" src="@/assets/images/jtl.png" alt=""><img v-show="step != 0"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 1 ? 'item itemed' : 'item'">剧情梗概</div>
          <div class="jt"><img v-show="step == 1" src="@/assets/images/jtl.png" alt=""><img v-show="step != 1"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 2 ? 'item itemed' : 'item'">分段脚本</div>
          <div class="jt"><img v-show="step == 2" src="@/assets/images/jtl.png" alt=""><img v-show="step != 2"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 3 ? 'item itemed' : 'item'">角色设计</div>
          <div class="jt"><img v-show="step == 3" src="@/assets/images/jtl.png" alt=""><img v-show="step != 3"
              src="@/assets/images/jth.png" alt=""></div>
          <div :class="step == 4 ? 'item itemed' : 'item'">生成分镜</div>
        </div>
      </div>
      <div class="center-body">
        <div class="stepbox step1">
          <div class="thinkipt" :style="isgj ? 'top:-500px' : 'top:70px'">
            <div class="think1"><textarea v-model="think" class="custom-scrollbar" placeholder="输入您的创意" name=""
                id="" @keyup.enter="getGenerate"></textarea> <img class="bx" src="@/assets/images/bx.png" alt="" @click="getGenerate"></div>
            <!-- <div class="think2">
              <div class="l"></div>
              <div class="r">
                <div :class="thinktype === 0 ? 'r1 r2' : 'r1'" @click="thinktype = 0">故事片</div>
                <div :class="thinktype !== 0 ? 'r1 r2' : 'r1'" @click="thinktype = 1">产品片</div>
              </div>
            </div> -->
            <div class="hidden" @click="isgj = true">高级创作</div>
          </div>
          <div class="thinkgj" :style="isgj ? 'top:80px' : 'top:-1000px'">
            <textarea class="custom-scrollbar" name="" id="" placeholder="输入您的创意"></textarea>
            <div class="form">
              <div class="item">
                <div class="l">我是</div>
                <div class="r"><input v-model="highForm.f1" type="text" placeholder="名称"></div>
              </div>
              <div class="item">
                <div class="l">角色</div>
                <div class="r"><input v-model="highForm.f2" type="text" placeholder="次要角色/产品，如恐龙、咖啡"></div>
              </div>
              <div class="item">
                <div class="l">场景</div>
                <div class="r"><input v-model="highForm.f3" type="text" placeholder="地点/天气，比如下雨的广场、晴天的森林"></div>
              </div>
              <div class="item">
                <div class="l">时间</div>
                <div class="r"><input v-model="highForm.f4" type="text" placeholder="白天、夜晚、黄昏等"></div>
              </div>
              <div class="item">
                <div class="l">内容情绪</div>
                <div class="r"><input v-model="highForm.f5" type="text" placeholder="快节奏、紧张、悬念、幽默等"></div>
              </div>
              <div class="item">
                <div class="l">视觉风格</div>
                <div class="r"><input v-model="highForm.f6" type="text" placeholder="电影胶片风格、卡通片、广告胶片等"></div>
              </div>
              <div class="item">
                <div class="l">色调</div>
                <div class="r"><input v-model="highForm.f7" type="text" placeholder="金色调、白调、粉色调等"></div>
              </div>
              <div class="item">
                <div class="l">故事</div>
                <div class="r"><input v-model="highForm.f8" type="text" placeholder="故事发展的过程或是镜头中主体的动作"></div>
              </div>
              <div class="item">
                <div class="l">描述</div>
                <div class="r"><input v-model="highForm.f9" type="text" placeholder="比如恐龙去咖啡厅买咖啡，带回森林"></div>
              </div>
              <div class="item">
                <div class="l">营销目的</div>
                <div class="r"><input v-model="highForm.f10" type="text" placeholder="增加产值"></div>
              </div>
            </div>
            <div class="submit" @click="getGenerateHigh">创意</div>
            <div class="hidden" @click="isgj = false">普通创作</div>
          </div>
          <!-- 推荐 -->
          <!-- <div class="recommend" :style="isgj ? 'top:1000px' : 'top:300px'">
            <div class="item">
              <div class="it1">
                <div v-for="(item, index) in recommend.item1" :key="index" @click="setsea(item)">{{ item }}</div>
              </div>
              <div class="it1">
                <div v-for="(item, index) in recommend.item1" :key="index" @click="setsea(item)">{{ item }}</div>
              </div>
            </div>
            <div class="item">
              <div class="it1">
                <div v-for="(item, index) in recommend.item2" :key="index" @click="setsea(item)">{{ item }}</div>
              </div>
              <div class="it1">
                <div v-for="(item, index) in recommend.item2" :key="index" @click="setsea(item)">{{ item }}</div>
              </div>
            </div>
            <div class="item">
              <div class="it1">
                <div v-for="(item, index) in recommend.item3" :key="index" @click="setsea(item)">{{ item }}</div>
              </div>
              <div class="it1">
                <div v-for="(item, index) in recommend.item3" :key="index" @click="setsea(item)">{{ item }}</div>
              </div>
            </div>
            <div class="item">
              <div class="it1">
                <div v-for="(item, index) in recommend.item4" :key="index" @click="setsea(item)">{{ item }}</div>
              </div>
              <div class="it1">
                <div v-for="(item, index) in recommend.item4" :key="index" @click="setsea(item)">{{ item }}</div>
              </div>
            </div>
            <div class="item">
              <div class="it1">
                <div v-for="(item, index) in recommend.item5" :key="index" @click="setsea(item)">{{ item }}</div>
              </div>
              <div class="it1">
                <div v-for="(item, index) in recommend.item5" :key="index" @click="setsea(item)">{{ item }}</div>
              </div>
            </div>
          </div> -->
          <!-- </div> -->

        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "",
  data () {
    return {
      id: 0,
      his: [],
      step: 0,
      highForm: {
        f1: '',
        f2: '',
        f3: '',
        f4: '',
        f5: '',
        f6: '',
        f7: '',
        f8: '',
        f9: '',
        f10: ''
      },
      recommend: {
        item1: ['一支时尚风格的运动鞋广告，适合夏季投放', '教育玩具广告，亲子互动', '瓶装雪山精华水广告，白金色调，贴近自然、高端奢华'],
        item2: ['健康食品广告，使用绿色与自然元素，适合在健康类博客推广', '宠物用品视频，舒适安全', '奢华手表广告，黑金色调'],
        item3: ['高端美容品牌的产品视频，重点突出产品包装与设计，适合商场内播放', '手工皮具视频，高端质感'],
        item4: ['健康食品广告，使用绿色与自然元素，适合在健康类博客推广', '宠物用品视频，舒适安全', '奢华手表广告，黑金色调'],
        item5: ['高端美容品牌的产品视频，重点突出产品包装与设计，适合商场内播放', '手工皮具视频，高端质感']
      },
      thinktype: 0,
      think: '',
      isgj: false,
    }
  },
  async created () {
    this.id = this.$route.query.id
    const res = await this.$http('api.getIdeas', { project_id: this.id })
    this.his = res.data
  },
  mounted () {
    this.$bus.$emit('menu-active', false)
  },

  methods: {
    setsea (val) {
      this.think = val
    },
    // 获取故事梗概,普通
    async getGenerate () {
      this.step = 1
      this.loading1 = true
      const data = {
        project_id: this.id,
        user_input: this.think,
        // prompt_params: `${this.think}。这是一个${this.thinktype === 0 ? '故事片' : '产品片'}`
        prompt_params: `${this.think}`

      }
      sessionStorage.setItem('index2', JSON.stringify(data))
      this.$router.push(`/project2/project2_2?id=${this.id}`)
      // const res = await this.$http('api.getGenerate', data)
      // this.resetdata(res.data)
    },
    // 获取故事梗概,高级
    async getGenerateHigh () {
      const des = this.resetForm()
      this.step = 1
      const data = {
        project_id: this.id,
        user_input: des,
        prompt_params: des
      }
      sessionStorage.setItem('index2', JSON.stringify(data))
      this.$router.push(`/project2/project2_2?id=${this.id}`)
      // const res = await this.$http('api.getGenerate', data)
      // this.resetdata(res.data)
    },
    resetForm () {
      let str = '生成一个剧本梗概，'
      if (this.highForm.f1 !== '') {
        str += `主角是${this.highForm.f1},`
      }
      if (this.highForm.f2 !== '') {
        str += `次要角色是${this.highForm.f2},`
      }
      if (this.highForm.f3 !== '') {
        str += `场景是${this.highForm.f3},`
      }
      if (this.highForm.f4 !== '') {
        str += `时间是${this.highForm.f4},`
      }
      if (this.highForm.f5 !== '') {
        str += `内容情绪是${this.highForm.f5},`
      }
      if (this.highForm.f6 !== '') {
        str += `视觉风格是${this.highForm.f6},`
      }
      if (this.highForm.f7 !== '') {
        str += `色调是${this.highForm.f7},`
      }
      if (this.highForm.f8 !== '') {
        str += `发展过程是${this.highForm.f8},`
      }
      if (this.highForm.f9 !== '') {
        str += `这是一段描述内容:${this.highForm.f9},`
      }
      if (this.highForm.f10 !== '') {
        str += `营销目的是${this.highForm.f10},`
      }
      return str
    },
    // 查看更改历史
    checkhis(val){
      this.$router.push(`/project2/project2_2?id=${this.id}&record_id=${val.id}`)
    }
  }
}
</script>
<style lang="scss" scoped>
.space {
  width: 100%;
  height: 100%;
  display: flex;

  .history {
    width: 300px;
    height: 100%;
    background-color: #f1f1f1;
    padding: 20px;

    .his1 {
      font-size: 16px;
      color: #636262;
    }

    .his-body {
      margin-top: 20px;
      height: calc(100vh - 150px);
      width: 100%;
      overflow: auto;

      .item {
        width: 100%;
        font-size: 16px;
        margin-bottom: 24px;
        color: #595959;
        height: 20px;
        line-height: 20px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: pointer;
      }

      .item:hover {
        color: #3f81e4;
      }
    }
  }

  .center {
    flex: 1;
    // padding: 20px;
    height: calc(100vh - 80px);

    .center-top {
      margin-top: 20px;
      height: 44px;
      position: relative;

      .return,
      .next {
        position: absolute;
        width: 134px;
        text-align: center;
        height: 36px;
        line-height: 36px;
        top: 50%;
        transform: translateY(-50%);
        background: #FFFFFF;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #DDDDDD;
        cursor: pointer;

        img {
          width: 20px;
          margin-right: 4px;
          transform: translateY(-2px);
        }
      }

      .return {
        left: 20px;
      }

      .next {
        right: 20px;
      }

      .step {
        margin: 0 auto;
        width: 620px;
        height: 44px;
        line-height: 44px;
        background: #FFFFFF;
        box-shadow: 2px 2px 12px 0px rgba(97, 92, 92, 0.2);
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #046DFA;
        display: flex;
        justify-content: center;

        .item {
          font-size: 18px;
          color: #595959;
        }

        .itemed {
          font-weight: bold;
          color: #046DFA;
        }

        .jt {
          margin: 0 16px;

          img {
            width: 16px;
          }
        }
      }
    }

    .center-body {
      margin: 0 auto;
      width: 100%;
      margin-top: 20px;
      height: calc(100vh - 180px);
      overflow: hidden;

      .stepbox {
        width: 100%;
        height: 100%;
        overflow: hidden;
        position: relative;

      }

      .step1 {

        .thinkipt {
          width: 90%;
          height: 144px;
          background: #FFFFFF;
          box-shadow: 4px 4px 20px 0px rgba(105, 105, 105, 0.25);
          border-radius: 16px 16px 16px 16px;
          border: 1px solid #0F172A;
          position: absolute;
          left: 50%;
          top: 70px;
          transform: translateX(-50%);
          transition: all .5s linear;

          .think1 {
            display: flex;
            justify-content: space-between;

            textarea {
              
              margin-top: 10px;
              margin-left: 10px;
              width: 900px;
              height: 120px;
              border: none;
              padding: 10px;
              background-color: transparent;
              resize: none;
              font-size: 16px;
            }

            .bx {
              width: 48px;
              height: 48px;
              margin-top: 40px;
              margin-right: 20px;
              cursor: pointer;
            }
          }

          .think2 {
            display: flex;
            justify-content: space-between;
            margin-top: 6px;

            .r {
              margin-right: 20px;
              display: flex;

              .r1 {
                margin-left: -12px;
                width: 80px;
                text-align: center;
                line-height: 30px;
                height: 30px;
                background: #EEEEEE;
                border-radius: 25px 25px 25px 25px;
                cursor: pointer;
              }

              .r2 {
                position: relative;
                z-index: 2;
                background: #046DFA;
                color: white;

              }
            }

          }

          .hidden {
            position: absolute;
            bottom: -40px;
            left: 50%;
            transform: translateX(-50%);
            width: 100px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            background-color: #046ffad2;
            color: white;
            border-radius: 12px;
            cursor: pointer;
          }
        }

        .recommend {
          width: 100%;
          height: 500px;
          // background-color: skyblue;
          position: absolute;
          left: 50%;
          top: 300px;
          transform: translateX(-50%);
          transition: all .5s linear;

          .item {
            display: flex;
            width: 200%;
            height: 50px;
            margin-bottom: 40px;
            animation: tm 10s linear infinite;

            .it1 {
              width: 100%;
              display: flex;
              justify-content: space-between;

              div {
                padding: 0 10px;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                color: #8C8C8C;
                background: #F5F7FD;
                border-radius: 30px 30px 30px 30px;
                margin-right: 60px;
                cursor: pointer;
              }
            }

          }

          .item:nth-child(2) {
            animation: tm 12s linear infinite;
          }

          .item:nth-child(3) {
            animation: tm 14s linear infinite;
          }

          .item:nth-child(4) {
            animation: tm 18s linear infinite;
          }

          .item:nth-child(5) {
            animation: tm 22s linear infinite;
          }

          @keyframes tm {
            0% {
              margin-left: 0%;
            }

            100% {
              margin-left: -100%;
            }
          }
        }

        .thinkgj {
          position: absolute;
          left: 50%;
          top: 20px;
          transform: translateX(-50%);
          width: 1000px;
          height: 548px;
          background: #F8F8F8;
          border-radius: 16px 16px 16px 16px;
          transition: all .5s linear;
          padding: 24px;

          textarea {
            width: 100%;
            height: 120px;
            background: #FFFFFF;
            border-radius: 12px 12px 12px 12px;
            border: 1px solid #D9D9D9;
            resize: none;
            padding: 10px;
            font-size: 16px;
          }

          .form {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;

            .item {
              margin-top: 20px;
              width: 49%;
              display: flex;

              .l {
                width: 80px;
                font-size: 16px;
                line-height: 44px;
                color: #262626;
              }

              .r {
                flex: 1;

                input {
                  width: 100%;
                  height: 44px;
                  background: #FFFFFF;
                  border-radius: 4px 4px 4px 4px;
                  border: 1px solid #D9D9D9;
                  padding-left: 10px;
                }
              }
            }
          }

          .submit {
            cursor: pointer;
            margin: 0 auto;
            margin-top: 20px;
            width: 214px;
            line-height: 44px;
            text-align: center;
            font-size: 16px;
            color: #FFFFFF;
            height: 44px;
            background: linear-gradient(90deg, #66AFFF 0%, #046CF3 100%);
            border-radius: 12px 12px 12px 12px;
          }

          .hidden {
            position: absolute;
            top: -40px;
            left: 50%;
            transform: translateX(-50%);
            width: 100px;
            height: 26px;
            line-height: 26px;
            text-align: center;
            background-color: #046ffad2;
            color: white;
            border-radius: 12px;
            cursor: pointer;
          }
        }
      }

      .step2 {
        padding: 0 20px;

        .con {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;

          .item {
            padding: 20px;
            background: #F8F8F8;
            margin-top: 24px;
            width: 48%;
            height: 280px;
            border-radius: 12px 12px 12px 12px;
          }
        }

        .loading {
          .l1 {
            margin-top: 10px;
            width: 100%;
            text-align: center;
          }

          .js {
            font-size: 14px;
            color: #046DFA;
            margin-top: 12px;
            width: 100%;
            text-align: center;
          }

        }

        .loaded {
          .con {
            .item {
              border: 1px solid transparent;
              position: relative;

              .it1 {
                font-size: 18px;
                color: #262626;
              }

              .it2 {
                margin-top: 14px;
                width: 100%;

                height: 108px;

                textarea {
                  width: 100%;
                  height: 100%;
                  resize: none;
                  border-radius: 6px 6px 6px 6px;
                  border: 1px solid transparent;
                  padding: 10px;
                  background-color: transparent;
                }

                textarea:hover {
                  border: 1px solid #046DFA;
                }
              }

              .it3 {
                display: flex;
                margin-top: 40px;

                div {
                  margin-right: 6px;
                  padding: 4px 8px;
                  font-size: 13px;
                  color: #FFFFFF;
                  background: #595959;
                  border-radius: 30px 30px 30px 30px;
                }
              }

              .it4 {
                position: absolute;
                width: 60px;
                font-size: 14px;
                height: 30px;
                line-height: 30px;
                background: linear-gradient(90deg, #66AFFF 0%, #046CF3 100%);
                right: 20px;
                bottom: 10px;
                text-align: center;
                color: white;
                border-radius: 8px;
                cursor: pointer;
                display: none;
              }

              .it4:hover {
                background: linear-gradient(90deg, #84b5e9 0%, #4a8add 100%);
              }
            }

            .item:hover {
              border: 1px solid #046DFA;
            }

            .item:hover .it4 {
              display: block;
            }
          }

          .refresh {
            margin-top: 20px;
            display: flex;
            font-size: 16px;
            color: #595959;
            justify-content: right;
            cursor: pointer;

            img {
              width: 20px;
              margin-right: 4px;
              transform: translateY(-2px);
            }
          }
        }
      }

      .step3 {
        padding: 0 20px;
        display: flex;
        justify-content: space-between;

        .l {
          width: 69%;
          height: 100%;
          background: #F8F8F8;
          border-radius: 16px 16px 16px 16px;
          padding: 20px;
          position: relative;
          overflow: auto;

          .l1 {
            // margin-top: 300px;
            width: 100%;
            text-align: center;
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);

            .js {
              margin-top: 30px;
              font-size: 14px;
              color: #046DFA;
              width: 100%;
              text-align: center;
            }
          }

          .item {
            width: 100%;
            margin-bottom: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid #b4b2b2;

            .it1 {
              display: flex;
              justify-content: space-between;
              width: 100%;

              .left {
                width: 80%;
                color: #262626;
                display: flex;
                line-height: 40px;

                span {
                  line-height: 40px;
                  font-size: 20px;
                  margin-right: 10px;
                }

                input {
                  padding: 0 10px;
                  border: 1px solid transparent;
                  flex: 1;
                  height: 40px;
                  font-size: 20px;
                  background-color: transparent;
                }

                input:hover {
                  border: 1px solid #3c6fcf;
                }
              }

              .right {
                display: none;
                margin-top: 10px;

                span {
                  cursor: pointer;
                  font-size: 16px;
                  color: #595959;
                  margin-right: 20px;

                  img {
                    width: 24px;
                    margin-right: 2px;
                    transform: translateY(-2px);
                  }
                }
              }
            }

            .tsipt {
              outline: none;
              margin-top: 20px;
              padding: 10px;
              width: 100%;
              height: auto;
              resize: none;
              border: 1px solid transparent;
              background-color: transparent;
            }

            .tsipt:hover {
              border: 1px solid #407cd4;
            }
          }

          .item:last-child {
            border-bottom: none;
            margin-bottom: 0;
          }

          .item:hover .it1 .right {
            display: block;
          }

        }

        .r {
          padding: 20px;
          width: 29%;
          height: 100%;
          background: #F8F8F8;
          border-radius: 16px 16px 16px 16px;
          overflow: auto;

          .r1 {
            font-size: 24px;
            color: #262626;
          }

          .r2 {
            margin-top: 10px;
            padding-bottom: 20px;
            height: 600px;
            overflow: auto;

            .line {
              margin-top: 20px;
              width: 100%;
              display: flex;
              justify-content: space-between;

              .item {
                width: 90%;
                padding: 10px;
                background: #FFFFFF;
                border-radius: 8px 8px 8px 8px;
                border: 1px solid #DDDDDD;
              }

              .del {
                height: 30px;
                font-size: 30px;
                color: #fa7a7a;
                cursor: pointer;
              }

              .del:hover {
                color: #f72b2b;
              }
            }

          }

          .r3 {
            cursor: pointer;
            float: right;
            margin-top: 20px;
            color: white;
            width: 100px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            background: linear-gradient(90deg, #66AFFF 0%, #046CF3 100%);
            border-radius: 8px;
          }

          .r3:hover {
            background: linear-gradient(90deg, #66AFFF 0%, #4b64f5 100%);
          }
        }

      }

      .step4 {
        padding: 0 20px;
        display: flex;
        justify-content: space-between;

        .st4_l {
          width: 79%;
          height: 100%;
          border-radius: 16px;
          background-color: rgb(241, 241, 241);
          padding: 20px;

          .loading {
            width: 100%;

            .lod1 {
              width: 100%;
              text-align: center;
              margin-top: 200px;

              .js {
                margin-top: 20px;
              }
            }
          }

          .top {
            height: 30px;
            font-size: 24px;
            line-height: 30px;
            display: flex;

            span {
              cursor: pointer;
              margin-left: 20px;
              font-size: 16px;

              img {
                margin-right: 4px;
                width: 16px;
                transform: translateY(-2px);
              }
            }
          }

          .s_body {
            height: 600px;
            overflow: auto;
            width: 100%;
            margin-top: 20px;
            display: flex;
            flex-wrap: wrap;

            .item {
              margin-bottom: 20px;
              margin-left: 20px;
              width: 240px;
              padding: 10px;
              height: 500px;
              border-radius: 8px;
              border: 1px solid #d1d1d1;

              .it1 {
                width: 100%;
                height: 280px;
                overflow: hidden;
                border-radius: 8px;

                .k {
                  background-color: #d1cfcf;
                  width: 100%;
                  height: 100%;
                  text-align: center;

                  img {
                    width: 50px;
                    margin-top: 80px;
                  }

                  .tip {
                    width: 100%;
                    text-align: center;
                    font-size: 14px;
                    margin-top: 10px;
                    color: #7c7c7c;
                  }
                }

                .img {
                  width: 100%;
                  height: 100%;
                  position: relative;
                  background-color: #e2dfdf;

                  .download {
                    display: none;
                    top: 10px;
                    right: 10px;
                    position: absolute;
                    z-index: 2;
                    width: 30px;
                    height: 30px;
                    text-align: center;
                    background-color: #313131;
                    border-radius: 4px;
                    cursor: pointer;

                    img {
                      margin-left: 5px;
                      margin-top: 1px;
                      width: 20px;
                      height: 20px;
                    }
                  }

                  img {
                    position: absolute;
                    width: 100%;
                    top: 50%;
                    left: 0;
                    transform: translateY(-50%);
                  }
                }

                .img:hover .download {
                  display: block;
                }
              }

              .it2,
              .it3 {
                margin-top: 4px;
                width: 100%;
                height: 30px;
                line-height: 30px;
                position: relative;
                font-size: 14px;

                input {
                  padding-left: 40px;
                  width: 100%;
                  height: 100%;
                  border: 1px solid #b9b7b7;
                  border-radius: 4px;
                }

                span {
                  position: absolute;
                  height: 30px;
                  line-height: 30px;
                  width: 50px;
                  font-size: 14px;
                  left: 4px;
                }

                img {}

                .refresh {
                  position: absolute;
                  right: 10px;
                  width: 16px;
                  top: 50%;
                  transform: translateY(-50%);
                  cursor: pointer;

                  img {
                    width: 100%;
                    height: 100%;
                  }
                }
              }

              .it4 {
                font-size: 14px;

                span {
                  display: block;
                  margin: 4px 0;
                  font-size: 14px;
                }

                textarea {

                  resize: none;
                  width: 100%;
                  height: 100px;
                  border: 1px solid #b9b7b7;
                  border-radius: 4px;
                  padding: 10px;
                }
              }
            }
          }
        }

        .st4_r {
          padding: 10px;
          width: 19%;
          height: 100%;
          border-radius: 16px;
          background-color: rgb(241, 241, 241);

          .sr1 {
            width: 100%;
            margin-bottom: 20px;

            .top {
              margin-bottom: 10px;
            }

            .bottom {
              width: 100%;

              >div {
                width: 100%;
              }

              textarea {
                padding: 10px;
                width: 100%;
                height: 80px;
                border: 1px solid #e2e2e2;
                border-radius: 4px;
                font-size: 14px;
                resize: none;
              }

              textarea:hover {
                border: 1px solid #1f70da;
              }
            }
          }
        }
      }

      .step5 {
        padding: 0 20px;
      }
    }
  }
}
</style>